export default "__VITE_ASSET__B0a71hgL__"